// extracted by mini-css-extract-plugin
export default {"container":"LegalNoticeModalBody_container__+9C2j","legalConfirm":"LegalNoticeModalBody_legalConfirm__YzLDO","buttonSection":"LegalNoticeModalBody_buttonSection__8gCCZ"};